<template>
  <div class="orderDetail">
    <van-nav-bar
      ref="nav"
      :border="false"
      @click-left="$store.dispatch('back')"
      placeholder
      :fixed="true"
      title="订单详情"
    >
      <template #left>
        <van-icon size="40rpx" name="arrow-left" color="#333" /> 
      </template>
    </van-nav-bar>
    <div class="status finish" v-if="base_info.status == 4 || base_info.status == 5">
      <div v-if="base_info.status == 4">支付完成</div>
      <div v-if="base_info.status == 5">已取消</div>
      <p>感谢您选择婴幼高研院，我们将持续为您提供</p>
    </div>
    <div class="status finish" v-if="base_info.status == 1">
      <div>等待支付，剩余 
        <!-- <p> {{ minute }}:{{ second }}</p> -->
        <van-count-down :time="time" format="mm:ss" @finish="getData" v-if="time > 0" class="countDown"/>
      </div>
      <p>超时未支付订单将自动取消</p>
    </div>
    <div class="bg productInfo">
      <img :src="goods_info.cover_mobile || $tuoyuPlaceImg"/>
      <div><p>{{ goods_info.name }}</p>￥{{ goods_info.price }}</div>
    </div>
    <div class="bg orderInfo">
      <p><span>合计</span>{{ base_info.amount }}</p>
      <p><span>优惠抵减</span>{{ (base_info.amount_should-base_info.amount).toFixed(2) }}</p>
      <p><span>订单编号</span>{{ base_info.orderno }}</p>
      <p><span>提交时间</span>{{ base_info.created_at }}</p>
      <p  v-if="base_info.status == 4"><span>支付方式</span>{{ base_info.pay_type_name }}</p>
      <p  v-if="base_info.status == 4"><span>付款时间</span>{{ base_info.pay_time }}</p>
      <p  v-if="base_info.status == 4"><span>成交时间</span>{{ base_info.finish_time }}</p>
    </div>
    <div class="footer" v-if="base_info.status == 1">
       <p>应付金额：<span>¥{{goods_info.price}}</span></p>
       <div class="btn">
          <!-- <p @click="toDel(6)" class="gray" v-if="base_info.status !=1">删除订单</p> -->
          <p @click="toDel(5)" class="gray" v-if="base_info.status == 1">取消订单</p>
          <p @click="toPay" class="yellow" v-if="base_info.status == 1">立即支付</p>
       </div>
    </div>
    <div class="footer" v-if="base_info.status !== 1">
       <p><a href="tel:13811674685"></span>客服电话：<span>13811674685</span></a></p>
    </div>
    
  </div>
</template>


<script>
import store from "@/store/index.js";
//     import Vue from 'vue'
//     import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

export default {
  components: { 
  },
  computed: {
    partalName() {
      return store.state.partal.name;
    },
  },
  data() {
    return {
      time:0,
      base_info:{},
      goods_info: {},
      timer:null,
    };
  },
  async mounted () {
 
    this.getData();
  },
  
  methods: {
    async getData() {
      this.pageLoading = true;
     
        let res = await this.$request.orderDetail(this.$route.query.id)
        this.pageLoading = false;
        if(res.code == 0){
          this.base_info = res.data.base_info
          this.goods_info = res.data.goods_info[0]
          if(this.base_info.status == 1){
            this.time = new Date(this.base_info.created_at.replace(/-/g,'/')).getTime() + 10 * 60 * 1000 - new Date().getTime()
          }
        } else {
          this.$toast(res.msg);
        }
    },
    toDel(status){
      this.$dialog.confirm({
        title: '',
        message:
          `确定${status==5?'取消':'删除'}当前订单?`,
      })
        .then(() => {
          this.$request.orderDel(this.base_info.orderno,status).then(res=>{
            if(res.code == 0){
              this.$toast.success(`${status==5?'取消':'删除'}成功`);
              if(status==5){
                this.base_info.status = 5
              }else{
                this.$router.go(-1);
              }
            }else{
              this.$toast(res.msg);
            }
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    async toPay() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      if(this.$until.isWeiXin() && window.localStorage.getItem('isH5')!=1){
      
        this.wxPay()
      }else{
        this.noWxPay()
      }
      
    },
    // 非微信环境支付
    async noWxPay(){
      let res = await this.$api({
              url: "/api/order/make/again",
              method: "POST",
              data: {
                pay_type: 7,
                order_sn:this.base_info.orderno,
              },
            });
            console.log(res)
            if (res.code == 0) {
              let payInfo = res.data.pay
              window.location.href = payInfo.mweb_url+ '&redirect_url=' + encodeURIComponent(window.location.href+'#/'+this.$route.params.plat_type+'/user/purchased')
              this.$toast.clear();
              
            } else {
              this.$toast.clear();
              this.$toast(res.msg);
            }
    },
    // 微信环境支付
    async wxPay(){
      console.log('微信支付2')
      let res = await this.$api({
              url: "/api/order/make/again",
              method: "POST",
              data: {
                pay_type: 9,
                order_sn:this.base_info.orderno,
                openid: localStorage.getItem('openid'),
              },
            });
            if (res.code == 0) {
              let payInfo = res.data.pay
              this.$toast.clear();
              // this.$wechat.pay(payInfo)
              function onBridgeReady() {
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  {
                    appId: "wxb1d573e34d48cbf6",
                    timeStamp: payInfo.timeStamp + "", //时间戳，自1970年以来的秒数
                    nonceStr: payInfo.nonceStr, //随机串
                    package: payInfo.package,
                    signType: payInfo.signType, //微信签名方式：
                    paySign: payInfo.paySign, //微信签名◊
                  },
                  function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      this.$toast({
                        title: "支付成功",
                        icon: "none",
                      });
                      setTimeout(() => {
                        this.$router.replace('../user/purchased')
                        // this.$store.dispatch("reJump", {
                        //   path: "../user/purchased",
                        //   params: "",
                        // });
                      }, 300);
                    }
                  }
                );
              }
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    onBridgeReady,
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
                  document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
                }
              } else {
                onBridgeReady();
              }
              
            } else {
              this.$toast.clear();
              this.$toast(res.msg);
            }
    },
  }
};
</script>
<style lang="scss">
.orderDetail .van-nav-bar{
  background-color: transparent;
}
  .countDown{
    color: #F08E00;
    font-size: 40px;
    font-weight: 600;
    line-height: 56px;
    margin-left: 10px;
  }
</style>
<style scoped lang="scss">
.orderDetail {
  background-color: #F9F9F9;
  height: 100vh;
}

.footer {
  width: 100%;
  padding: 30px 32px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px -1rpx 5rpx 0px #ddd9d9;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: constant(safe-area-inset-bottom);
  >p{
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    flex: 1;
    a{
      color: #333;
      text-align: center;
      width: 100%;
      display: block;
    }
    span{
      color: #F08E00;
    }
  }
  .btn{
    display: flex;
    p{
      width: 160px;
      height: 64px;
      line-height: 64px;
      background: #FFFFFF;
      border-radius: 32px;
      border: 2px solid #E5E5E5;
      font-size: 24px;
      text-align: center;
      color: #333333;
      margin-left: 20px;
    }
    .yellow{
      background: #F08E00;
      border-color: #F08E00;
      color: #fff;
    }
  }
}

  .bg{
    background: #fff;
    border-radius: 12px;
    margin: 32px 20px;
    padding: 32px 24px;
  }
  .productInfo{
    display: flex;
    color: #333;
    font-size: 20px;
    align-items: center;
    img{
      width: 256px;
      height: 144px;
      border-radius: 8px;
      margin-right: 22px;
      overflow: hidden;
      object-fit: cover;
    }
    >div{
      flex: 1;
      font-size: 28px;
      font-weight: 500;
      color: #F08E00;
      line-height: 40px;
      p{
        color: #333333;
        margin-bottom: 20px;
      }
    }
  }
  .orderInfo{
    font-size: 28px;
    font-weight: 400;
    color: #999999;

    line-height: 40px;
    p{
      &:not(:last-of-type){
        margin-bottom: 20px;
      }
      span{
        color: #333333;
        display: inline-block;
        width: 180px;
      }
    }
  }
  .status{
    padding:  62px 32px 0;
    >div{
      font-size: 40px;
      font-weight: 600;
      color: #000000;
      line-height: 56px;
      padding-bottom: 10px;
      display: flex;
      align-items: center;
    }
    >p{
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 34px;
    }
  }
</style>